<div class="loader-overlay" *ngIf="this.show">
  <div class="loader"></div>
</div>
